// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"About_wrapper__xT9XH","photo":"About_photo__3fQv7","address":"About_address__1MPHp"};